export default __webpack_public_path__ + "static/Inter-Regular-8c206db99195777c67691cbba9d64393.woff";